import { c as _c } from "react/compiler-runtime";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { MouseEvent } from "react";
import { useMemo } from "react";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import { getContributorLabel, type RepDirection } from "./UserPageRep.helpers";
const stopPropagation = (e: MouseEvent) => e.stopPropagation();
export default function RepCategoryPill(t0) {
  const $ = _c(42);
  const {
    category,
    canEdit,
    onEdit,
    compact: t1,
    direction: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const direction = t2 === undefined ? "received" : t2;
  const paddingClass = compact ? "tw-px-3 tw-py-2" : "tw-px-4 tw-py-2.5";
  let t3;
  if ($[0] !== category.top_contributors) {
    t3 = category.top_contributors.map(_temp);
    $[0] = category.top_contributors;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const avatarItems = t3;
  let t4;
  if ($[2] !== category.category) {
    t4 = <span className="tw-text-left tw-text-sm tw-font-medium tw-text-white">{category.category}</span>;
    $[2] = category.category;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== category.total_rep) {
    t5 = formatNumberWithCommas(category.total_rep);
    $[4] = category.total_rep;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-colors group-hover:tw-text-iron-300">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t4}{t6}</span>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-text-xs tw-text-white/20">·</span>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== avatarItems) {
    t9 = avatarItems.length > 0 && <span role="presentation" className="tw-pointer-events-none desktop-hover:tw-pointer-events-auto" onClick={stopPropagation}><OverlappingAvatars items={avatarItems} size="sm" maxCount={5} onItemClick={_temp2} /></span>;
    $[12] = avatarItems;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== category.contributor_count) {
    t10 = formatNumberWithCommas(category.contributor_count);
    $[14] = category.contributor_count;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== category.contributor_count || $[17] !== direction) {
    t11 = getContributorLabel(direction, category.contributor_count);
    $[16] = category.contributor_count;
    $[17] = direction;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{t10}{" "}{t11}</span>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t9) {
    t13 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t9}{t12}</span>;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== category.authenticated_user_contribution || $[26] !== direction) {
    t14 = !!category.authenticated_user_contribution && <><span className="tw-text-xs tw-text-white/20">·</span><span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{direction === "given" ? "To Me:" : "My Rate:"}{" "}<span className="tw-font-medium tw-text-primary-400">{formatNumberWithCommas(category.authenticated_user_contribution)}</span></span></>;
    $[25] = category.authenticated_user_contribution;
    $[26] = direction;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14 || $[30] !== t7) {
    t15 = <>{t7}{t8}{t13}{t14}</>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t7;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const content = t15;
  const baseClasses = `group tw-inline-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out ${paddingClass}`;
  if (canEdit) {
    let t16;
    if ($[32] !== category.category || $[33] !== onEdit) {
      t16 = () => onEdit(category.category);
      $[32] = category.category;
      $[33] = onEdit;
      $[34] = t16;
    } else {
      t16 = $[34];
    }
    const t17 = `${baseClasses} tw-cursor-pointer hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-shadow-md`;
    let t18;
    if ($[35] !== content || $[36] !== t16 || $[37] !== t17) {
      t18 = <button type="button" onClick={t16} className={t17}>{content}</button>;
      $[35] = content;
      $[36] = t16;
      $[37] = t17;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    return t18;
  }
  const t16 = `${baseClasses} tw-cursor-default`;
  let t17;
  if ($[39] !== content || $[40] !== t16) {
    t17 = <div className={t16}>{content}</div>;
    $[39] = content;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}
function _temp2(e) {
  return stopPropagation(e);
}
function _temp(c) {
  return {
    key: c.profile.handle ?? c.profile.primary_address,
    pfpUrl: c.profile.pfp ?? null,
    href: `/${c.profile.handle ?? c.profile.primary_address}`,
    ariaLabel: c.profile.handle ?? c.profile.primary_address,
    fallback: c.profile.handle ? c.profile.handle.charAt(0).toUpperCase() : "?",
    title: c.profile.handle ?? c.profile.primary_address,
    tooltipContent: <span>{c.profile.handle ?? c.profile.primary_address} ·{" "}{formatNumberWithCommas(c.contribution)}</span>
  };
}